const valueToPercentage = (value, min, max) =>
  (value - min) / (max - min);

export default valueToPercentage;